import React, { useState } from "react";
import * as yup from "yup";
import { MimaToastUtil } from "../../../components";
import constant from "../../../utils/constant";
import { EditAd } from "../../../pages/MoneyEx/MoneyExAds";
import { MoneyExController } from "../../../controllers";

const EditAdContainer = ({ closeModal, item }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object().shape({
    rate: yup
      .number()
      .required("Rate is required")
      .min(0, "Rate cannot be negative"),

    availableAmount: yup
      .number()
      .required("Available amount is required")
      .min(0, "Available amount cannot be negative"),

    minPerSale: yup
      .number()
      .required("Minimum per sale is required")
      .min(0, "Minimum per sale cannot be negative"),
  });

  const onSubmit = async (values) => {
    setLoading(true);

    const payload = {
      username: values.username,
      from: values.from,
      to: values.to,
      rate: values.rate,
      availableAmount: values.availableAmount,
      minPerSale: values.minPerSale,
    };

    const { status, errorMessage } = await MoneyExController.editAd(
      payload,
      item._id
    );
    if (status === constant.Success) {
      closeModal();
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
    }
    setLoading(false);
    return MimaToastUtil.error({
      message: errorMessage,
    });
  };

  return (
    <EditAd
      loading={loading}
      closeModal={closeModal}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      item={item}
    />
  );
};
export default EditAdContainer;
